<template>
  <v-container fluid>
    <!-- <div class="text-h4 text-md-h4 text-lg-h4 gris--text">Listado recibos</div> -->
    <!-- <v-typography variant="h4">Busca recibos y aplica pagos.</v-typography> -->
    <v-row no-gutters dense fluid>
      <v-col cols="12" xs="8" sm="6" md="3" lg="3" xl="2">
        <YearPicker v-model="selectedYear" />
      </v-col>
      <!-- <v-col xs="8" sm="6" md="3" lg="3" xl="2">
        <v-text-field v-model="Busqueda"   label="Busqueda"
        @input="onInputBusqueda" outlined dense></v-text-field>
      </v-col> -->

      <v-col xs="4" sm="4" md="2" lg="1" xl="1" class="text-center">
        <v-btn color="azul_med" @click.native="onClickFunction" dark elevation="0">Buscar</v-btn>
      </v-col>
      <v-col xs="4" sm="4" md="2" lg="1" xl="1" class="text-center">

        <v-btn color="azulclaro" @click.native="onClickDescargar" dark elevation="0"> <v-icon left>mdi-printer</v-icon>
          Imprimir</v-btn>
      </v-col>
      <v-col xs="4" sm="4" md="3" lg="4" xl="4" class="text-center">
      </v-col>
      <v-col no-gutters class="d-flex justify-end">
        <!-- <v-chip  class="ma-1" color="azul_med" outlined label>
          Total: {{ $formatCurrency(this.total) }}
      </v-chip>
      <v-chip class="ma-1" color="azul_med" outlined label>
          Aplicados: {{ $formatCurrency(this.totalPagados) }}
      </v-chip> -->
        <v-col no-gutters>
          Recibos aplicados: <strong>{{ this.pagados }} </strong> de <strong> {{ this.num_recibos }} </strong>
          <v-progress-circular :value="Porciento" :size="50" :width="5" color="green" rotate="-90">
            {{ Porciento }}%
          </v-progress-circular>
        </v-col>
        <!-- <v-chip class="ma-1" color="grey" outlined label>
          Faltante: {{ $formatCurrency(this.totalPendientes) }}
      </v-chip> -->
      </v-col>
    </v-row>
    <div class="cont-bord-gris">
      <v-row no-gutters justify="end" dense>
        <v-col>
          <v-list-item-subtitle>
            <v-chip dense class="ma-1" color="azul_med" outlined label>
              Pagados: {{ this.pagados
              }}
            </v-chip>
            <v-chip dense color="red" outlined dark label>
              Impago: {{ this.impago
              }}
            </v-chip>
            <v-chip dense class="ma-1" color="grey" outlined label>
              Total: {{ this.num_recibos
              }}
            </v-chip>
          </v-list-item-subtitle>
        </v-col>
        <v-col xs="2" sm="2" md="2" lg="2" xl="2"><v-select v-model="filtroPago" :items="opcionesFiltro"
            label="Filtrar por estado de pago" @change="filtrarDatos" dense outlined class="mb-4">
            <template v-slot:item="data">
              <v-list-item-content class="d-flex align-center">
                <v-icon left small class="mr-2">{{ data.item.icon }}</v-icon>
                <span>{{ data.item.text }}</span>
              </v-list-item-content>
            </template>

            <template v-slot:selection="data">
              <v-icon left small class="mr-2">{{ data.item.icon }}</v-icon>
              <span>{{ data.item.text }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col xs="6" sm="6" md="4" lg="5" xl="4">
          <v-text-field clearable v-model="search" append-icon="mdi-magnify" label="Buscar en tabla" single-line
            hide-details outlined dense></v-text-field>
        </v-col>
      </v-row>

      <v-data-table group-by="grupo" :items="datosFiltrados" :loading="loading" loading-text="  recibos..."
        :items-per-page="-1" fixed-header height="60vh" :custom-filter="customFilter" calculate-widths
        :headers="headers" dense :search="search" item-key="idpago" class="custom-data-table" :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          'items-per-page-text': 'Filas por página'
        }" no-data-text="No hay datos disponibles" no-results-text="No se encontraron resultados"
        @click:row="selectRow" :item-class="getRowClass">

        <template v-slot:item="{ item }">
          <tr @click="selectRow(item)" :class="{ 'selected-row': selectedRow && selectedRow === item.idpago }">

            <template>
              <td>
                <small>{{ item.idpago }}</small>
                <!-- <br/> <v-icon color="red" size="24">mdi-file-pdf-box</v-icon> | <v-icon color="blue" size="24">mdi-file-pdf-box</v-icon> -->
              </td>
            </template>
            <template>
              <td>
                <span style="font-size: 12px;">{{ item.contratante }}</span>
              </td>
            </template>
            <template>
              <td>
                <span style="font-size: 12px;"> {{ item.nombretitular }}</span>
              </td>
            </template>
            <template>
              <td>
                <span> <strong>{{ item.recibo }}</strong> de <strong>{{ item.recibos }}</strong></span>
              </td>
            </template>
            <template>
              <td v-if="item.pagado === 0">
                <span v-if="item.Diferencia > 1" class="text-rojo">{{ item.Diferencia }}
                  días</span>
                 <span v-if="item.Diferencia === 0" class="text-rojo">
                  Hoy</span>
                 <span v-if="item.Diferencia < 0" style="color: olivedrab;">A TIEMPO</span>
              </td>
              <td v-if="item.pagado === 1" :style="{ background: getColor(item.contrato) }">
                <span>
                  <v-btn v-if="item.pagado === 1 && item.Factura !== null" icon
                    :href="'https://api.medicover.mx/api/verfactura?membresia=' + item.Factura + '.pdf'"
                    target="_blank">
                    <v-icon size="20" color="red">mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <v-btn v-if="item.pagado === 1 && item.Factura !== null" icon
                    :href="'https://api.medicover.mx/api/verfactura?membresia=' + item.Factura + '.xml'"
                    target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <text x="6" y="19" font-size="6" fill="currentColor">&lt;XML&gt;</text>
                    </svg>
                  </v-btn>
                  <v-btn text dense v-if="item.pagado === 1 && item.Factura === null" @click="facturarPago(item)"
                    class="text--secondary">
                    FACTURAR
                  </v-btn>
                </span>
              </td>
            </template>
            <template>
              <td class="text-center" v-if="item.pagado === 0">
                IMPAGO
              </td>
              <td v-else dark class="elemento-pagado text-center">
                <strong>PAGADO</strong>
                <div class="small-chip">
                  {{ item.FormaPago }}
                </div>
              </td>
            </template>
            <template>
              <td>
                <span class="creado-style">{{ item.DatePagoFormat }}</span>
              </td>
            </template>
            <template>
              <td>
                <span class="creado-style"> {{ item.FecPagoFormat }}</span>
              </td>
            </template>
            <template>
              <td class="text-end">
                <span class="estatus-activo">{{ $formatCurrency(item.pago) }}</span>
              </td>
            </template>
            <template>
              <v-menu offset-z left open-on-click close-on-content-click>
                <template v-slot:activator="{ on, attrs }">
                  <td><v-btn @click="selectRow(item)"
                      :class="{ 'selected-row': selectedRow && selectedRow === item.idpago }" red icon v-bind="attrs"
                      v-on="on">
                      <v-icon size="28">mdi-dots-vertical-circle-outline</v-icon>
                    </v-btn></td>
                </template>
                <v-list>
                  <v-list-item :disabled="!(item.pagado == '0')" @click="openModalPago(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-cash-register</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> APLICA PAGO</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$verRecibo(item.idpago)">
                    <v-list-item-icon>
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> VER RECIBO</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="verPagos(item.contrato)">
                    <v-list-item-icon>
                      <v-icon>mdi-list-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> HISTORIAL DE RECIBOS</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="enviarCorreo(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-email-fast</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> ENVIAR RECIBO</v-list-item-title>
                  </v-list-item>

                </v-list>
              </v-menu>
            </template>
          </tr>
        </template>

      </v-data-table>
      <send-email-recibo-modal :isOpen.sync="showModalSendRecibo" :item="selectedPago" @close="closeModalSendPago" />

      <modal-list-pagos :isOpen.sync="isModLisPagos" :Membresia="this.MembresiaSelec || ''"></modal-list-pagos>

      <modal-pago :isOpen.sync="dialogPagoShow" :item="selectedPago" @save="aplicaPagoActiva"
        @close="dialogPagoShow = false"></modal-pago>

    </div>
  </v-container>
</template>
<script>

import YearPicker from '@/components/selectAnioComponent.vue'
import SendEmailReciboModal from '@/components/modals/modalSendEmailReciboComponent.vue'
import ModalPago from '@/components/Pagos/modalAplicaPagoComponent.vue'
import ModalListPagos from '@/components/modals/modalListPagosComponent.vue'


export default {
  name: 'InicioAgente',
  components: {
    YearPicker,
    SendEmailReciboModal,
    ModalPago,
    ModalListPagos,
  },
  watch: {
    "$route.params.mem"(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.search = newVal;
      }
    },
    selectedYear(val) {
      if (val) {
        this.Busqueda = null
      }
    }
  },
  computed: {
    duplicateColors() {
      const counts = {};
      const colors = {};
      const colorPalette = [
        "#FEF9F9", // Rosa pétalo suave
        "#FFFDF5", // Crema marfil
        "#FFFAF0", // Blanco durazno
        "#FFFCF2", // Beige nube
        "#FDF7FF", // Lavanda brisa
        "#F5F2FF", // Lila etéreo
        "#F0F9FF", // Azul celeste hielo
        "#EFFFFA", // Verde agua cristalino
        "#F6FFF0", // Verde lima neblina
        "#FFFFF0", // Amarillo algodón
        "#F8FFF8", // Verde menta nevada
        "#FCFFF4", // Amarillo pastel apagado
        "#FAFEFF", // Azul polar
        "#F4F8FF", // Azul neón apagado
        "#F0F0F0", // Gris perla claro
        "#FFFFFF", // Blanco puro
      ];

      let colorIndex = 0;

      this.pagos.forEach((item) => {
        counts[item.contrato] = (counts[item.contrato] || 0) + 1;
      });

      Object.keys(counts).forEach((key) => {
        if (counts[key] > 1) {
          colors[key] = colorPalette[colorIndex % colorPalette.length]; // Asigna colores en ciclo
          colorIndex++;
        }
      });
      return colors;
    }
  },
  mounted() {
    this.getPagosPendientes()
    this.search = this.$route.params.mem || null;
  },
  created() {
    //this.filtrarDatos(); // ✅ carga inicial con filtro "Todos"
  },
  data: () => ({
    showModalSendRecibo: false,
    bucketFormatos: process.env.VUE_APP_BUCKETFORMATOS,
    dialogPagoShow: false,
    selectedPago: {},
    Porciento: 0,
    snackbar: true,
    vertical: true,
    selectedRow: null,
    textAlert: '',
    NumRecibosSelec: null,
    MembresiaSelec: null,
    isModLisPagos: false,
    Busqueda: null,
    reciboSeleccionado: null,
    selectedYear: new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" }))
                    .toISOString().slice(0, 7),    search: '',
    pagos: [],
    expanded: [],
    total: 0,
    totalPagados: 0,
    totalPendientes: 0,
    headers: [
      { text: 'Folio', value: 'idpago', width: '5%', sortable: false },
      //{ text: 'Contrato', value: 'contrato', width: '10%', sortable: true },
      //{ text: "Contrato", value: "contrato", align: "d-none" }, // Columna oculta
      { text: 'Contratante', value: 'contratante', width: '15%', sortable: false },
      { text: 'Titular', value: 'nombretitular', width: '15%', sortable: false },
      //{ text: 'Agente', value: 'agente', sortable: true },
      { text: 'Recibo', value: 'recibo', width: '10%', sortable: false },
      { text: 'Retardo/factura', value: 'Diferencia', width: '10%', sortable: false },
      { text: 'Estatus', value: 'pagado', width: '10%', sortable: true },
      { text: 'FechaPago', value: 'DatePagoFormat', width: '10%', sortable: false },
      { text: 'Aplicado', value: 'FecPagoFormat', width: '10%', sortable: false },
      { text: 'Monto', value: 'pago', width: '5%', sortable: false, align: 'end' },
      { text: 'Opciones', value: 'ops', width: '5%', sortable: false, align: 'center' },
    ],
    num_recibos: 0,
    pagados: 0,
    impago: 0,
    loading: false,
    filtroPago: 'Todos', // valor inicial
    opcionesFiltro: [
      { text: 'Todos', value: 'Todos', icon: 'mdi-format-list-bulleted' },
      { text: 'Pagados', value: 'Pagados', icon: 'mdi-check-circle' },
      { text: 'No pagados', value: 'Nopagados', icon: 'mdi-close-circle' }
    ],
    datosFiltrados: []
  }),
  methods: {
    filtrarDatos() {
      if (this.filtroPago === 'Pagados') {
        this.datosFiltrados = this.pagos.filter(item => item.FecPagoFormat !== null);
      } else if (this.filtroPago === 'Nopagados') {
        this.datosFiltrados = this.pagos.filter(item => item.FecPagoFormat === null);
      } else {
        this.datosFiltrados = [...this.pagos]; // ✅ mostrar todos
      }
    },
    enviarCorreo(item) {
      this.selectedPago = item; // Pasamos el objeto al modal
      this.showModalSendRecibo = true;
    },
    closeModalSendPago(val) {
      this.showModalSendRecibo = val
    },
    customFilter(value, search, item) {
      return item.contrato.toLowerCase().includes(search.toLowerCase()) ||
        item.contratante.toLowerCase().includes(search.toLowerCase()) ||
        item.pago.toString().includes(search);
    },
    getColor(contrato) {
      return this.duplicateColors[contrato] || "transparent"; // Si no es duplicado, fondo transparente
    },
    openModalPago(item) {
      this.selectedPago = { ...item };
      this.dialogPagoShow = true;
    },
    facturarPago(item) {
      this.$http.post('Payment/UpdateFactura',{
        Folio: item.idpago,
        MetodoPago: ''
      })
      .then(response => {
        if (response.status === 200) {
          // this.$swal.fire.close();
          if (response.data) {
            item.Factura = response.data.factura;
            const index = this.pagos.findIndex(p => p.idpago === item.idpago);
            if (index !== -1) this.$set(this.pagos, index, { ...item });
            this.$swal.fire({
              toast: true,
              position: 'top-start',
              title: 'Correcto',
              text: response.data.message,
              icon: 'success',
              confirmButtonText: 'Cerrar',
              showCloseButton: false,
              showConfirmButton: true,
              timer: 4000,
              width: '40%',  // Más ancho
              backdrop: false // Evita que la alerta haga scroll al inicio
            })
          }
        }
        if (response.status === 409) {
          //this.$swal.fire.close();
          this.$swal.fire({
            position: 'center',
            // title: 'Valida',
            //text: 'Se genero un error',
            html: `No se puede facturar </b> ${response.data}.`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            backdrop: false, // Evita que la alerta haga scroll al inicio
            width: '400px',
            //timer: 1500,
          })
        }
      })
      .catch(() => {
          this.$swal.fire({
            position: 'center',
            // title: 'Valida',
            //text: 'Se genero un error',
            html: `No se pudo facturar, intenta mas tarde.`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            backdrop: false, // Evita que la alerta haga scroll al inicio
            width: '400px',
            //timer: 1500,
          })
      })
      .finally(() => {
        this.dialogPagoShow = false;
      });
    },
    aplicaPagoActiva(item) {
      console.log(item)
      this.$http.post('Payment',{
          Folio: item.idpago,
          MetodoPago: item.CodPago,
          Detalle: item.Referencia
        })
        .then(response => {
        if (response.status === 200) {
          const fechaHoy = new Date().toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }).replace(/\//g, "-");

          if (response.data) {
            item.pagado = 1
            item.FecPagoFormat = fechaHoy
            item.Factura = response.data.factura;
            const index = this.pagos.findIndex(p => p.idpago === item.idpago);
            if (index !== -1) this.$set(this.pagos, index, { ...item });
            //this.$swal.fire.close();
            this.$swal.fire({
              toast: true,
              position: 'top-start',
              title: 'Correcto',
              text: response.data.message,
              icon: 'success',
              confirmButtonText: 'Cerrar',
              showCloseButton: false,
              showConfirmButton: true,
              timer: 4000,
              width: '40%',  // Más ancho
              backdrop: false, // Evita que la alerta haga scroll al inicio
            })

          }
        }
        if (response.status === 409) {
          //this.$swal.fire.close()
          this.$swal.fire({
            position: 'center',
            // title: 'Valida',
            //text: 'Se genero un error',
            html: `No se puede aplicar el pago ya que </b> ${response.data}.`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            //timer: 1500,
            width: '400px',
            backdrop: false, // Evita que la alerta haga scroll al inicio
          })
        }
        })
        .catch(() => {
           this.$swal.fire({
              position: 'center',
              // title: 'Valida',
              //text: 'Se genero un error',
              html: `Ocurrio un error, el cual ya fue reportado. intente mas tarde.`,
              icon: 'error',
              confirmButtonText: 'Cerrar',
              showCloseButton: true,
              showConfirmButton: true,
              //timer: 1500,
              width: '400px',
              backdrop: false, // Evita que la alerta haga scroll al inicio
            })
           this.dialogPagoShow = false
        })
        .finally(() => {
          this.dialogPagoShow = false
        });
    },
    registraPago(pago) {
      pago.pagado = 1
      const index = this.pagos.findIndex(p => p.idpago === pago.idpago);
      if (index !== -1) this.$set(this.pagos, index, { ...pago });
    },
    Descargar() {
      var urltarjet = `${process.env.VUE_APP_BUCKETFORMATOS}Pagos/reportePagos?qry=${this.selectedYear}`
      var newTab = window.open(urltarjet);
      if (newTab) {
        newTab.focus();
      }
    },
    selectRow(item) {
      this.selectedRow = item.idpago;
    },
    getRowClass(item) {
      return this.selectedRow && this.selectedRow === item.idpago ? 'selected-row' : '';
      //return item.pagado === 1 ? 'pagado-row' : 'impago-row';
    },
    verPagos(data) {
      this.MembresiaSelec = data
      this.isModLisPagos = true
    },
    onClickFunction() {
      if(this.$route.params.mem){
        this.search = ''
      }
      this.getPagosPendientes()
    },
    verSoloPendientes() {
      this.selectedYear = null
      this.getPagosPendientes()
    },
    getPagosPendientes() {
      this.loading = true
      var url = this.selectedYear ? `Cobranza?qry=${this.selectedYear}` : `getCobranza`
      this.$http.get(url)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.datosFiltrados = this.pagos = response.data.map(pago => ({
                ...pago,
                grupo: `${pago.contrato} - ${pago.estado === '1' || pago.estado === 1 ? 'ACTIVA' : 'SUSPENDIDA'} -  ${pago.NomColectivo !== null ? '' + pago.NomColectivo : ''}`
              }))
              this.num_recibos = this.pagos.length;
              this.impago = this.pagos.filter(i => i.pagado === 0).length
              this.pagados = this.pagos.filter(i => i.pagado === 1).length
              this.Porciento = ((this.pagados / this.num_recibos) * 100).toFixed(0);
              this.total = this.pagos.reduce((total, pago) => total + pago.pago, 0);
              this.totalPagados = this.pagos.filter(pago => pago.pagado === 1)
                .reduce((total, pago) => total + pago.pago, 0);
              this.totalPendientes = this.pagos.filter(pago => pago.pagado === 0)
                .reduce((total, pago) => total + pago.pago, 0);
              this.loading = false
            }
          }
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          this.$swal.fire({
            position: 'center',
            // title: 'Valida',
            //text: 'Se genero un error',
            html: `Ha ocurrido un error inesperado, <b>intenta mas tarde</b> .`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            //timer: 1500,
          })
        });
    },
    registrarPago(item) {
      this.PagoSelect.Membresia = item.contrato
      this.PagoSelect.PagoNum = item.recibo + ' de ' + item.recibos
      this.PagoSelect.Folio = item.idpago
    },
    onInputBusqueda(value) {
      this.selectedYear = null,
        this.Busqueda = value
    }
  }
}
</script>
<style scoped>
.creado-style {
  font-weight: bold;
  color: #696969;
  font-size: 12px;
}

.impago-row .v-data-table__wrapper tbody tr {
  background-color: rgb(220, 239, 220) !important;
}

.custom-data-table .pagado-row {
  background-color: rgb(220, 239, 220) !important;
}

.custom-data-table .impago-row {
  background-color: rgb(255, 255, 25) !important;
}

.custom-data-table .older-row {
  background-color: #ffe4e1;
  /* Color para filas con edad > 30 */
}

.custom-data-table .younger-row {
  background-color: #e0ffff;
  /* Color para filas con edad <= 30 */
}

.elemento-pagado {
  background-color: #C8E6C9;
}

.small-chip {
  font-size: 10px;
  color: #575757;
}

.selected-row {
  background-color: #a0d0f4 !important;
  /* Color de fondo para la fila seleccionada */
}
</style>